import React from 'react';
import styled from 'styled-components';
import { fontSizes, inactiveColor, bodyTextColor } from '../constants/globalstyles';
import DoughnutGauge from 'areas/dashboard/components/DoughnutGauge';

interface TableTabsProps {
  onSelect?: (value: number) => void;
  selected?: number;
  options?: { label: string; percent: number }[];
}

const TableTabs: React.FC<TableTabsProps> = ({ onSelect = () => {}, selected, options }) => (
  <TabBar>
    {options?.map((item, i) => (
      <Tab key={i} selected={selected === i} onClick={() => onSelect(i)}>
        <DoughnutGauge complete={item.percent} percent={true} size="tiny" />
        <TabText>{item.label}</TabText>
      </Tab>
    ))}
  </TabBar>
);
export default TableTabs;

const TabBar = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  gap: 5px;
  overflow-x: auto;
  min-width: 0;
`;

const Tab = styled.div<{ selected?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: left;
  align-items: center;
  height: 70px;
  background-color: ${props => (props.selected ? '#f1f1f7' : '#ffffff')};
  border: 1px solid ${props => (props.selected ? '#bbb' : '#ddd')};
  font-style: normal;
  font-size: ${fontSizes.medium};
  line-height: 30px;
  cursor: pointer;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 4px;
  min-width: 150px;
  max-width: 200px;
  flex: 1;
  font-weight: ${props => (props.selected ? `500` : `400`)};
  color: ${props => (props.selected ? `${bodyTextColor}` : `${inactiveColor}`)};
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); /* Light drop shadow */

  /* Add hover effect */
  transition: box-shadow 0.3s ease; /* Smooth transition for hover effect */
  &:hover {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3); /* Light drop shadow */
  }
`;

const TabText = styled.div`
  text-align: center;
  margin-top: 5px;
  margin-bottom: 5px;
`;
